import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-entrance-exit-event',
  templateUrl: './manual-entrance-exit-event.component.html',
  styleUrls: ['./manual-entrance-exit-event.component.css'],
  standalone: false,
})
export class ManualEntranceExitEventComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly reflectDataLink: string = AppConst.ROUTING_LINK_MANUAL_REFLECT_DATA;
  readonly nameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;
  readonly descDialogLink: string = AppConst.ROUTING_LINK_MANUAL_DESC_DIALOG;
  readonly uploaderLink: string = AppConst.ROUTING_LINK_MANUAL_UPLOADER;
  readonly sendMailMessageDialogLink: string = AppConst.ROUTING_LINK_MANUAL_SEND_MAIL_MESSAGE_DIALOG;
  readonly floorDialogLink: string = AppConst.ROUTING_LINK_MANUAL_FLOOR_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
